const CustomerApp = () => {
    return <h3>CustomerApp</h3>
}

export default CustomerApp;